import { Button, Space } from "antd";
import { useDispatch } from "react-redux";
import { getData } from "../../actions/apiCall";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CheckCircleOutlined } from '@ant-design/icons';

const GraphAuth = () => {
    const [userToken, setUserToken] = useState(null);

    const { user } = useSelector((state: any) => state.app);
    const dispatch = useDispatch();

    const handleAuth = async () => {
        const resData = await dispatch(getData('/auth/login', {}, { baseURL: process.env.MAIL_SERVICE }));
        if (resData && resData.url) {
            window.location.href = resData.url;
        }
    }

    const checkAuth = async () => {
        try {
            if (!user || !user._id) {
                setUserToken(null);
                return;
            }
            const resData = await dispatch(getData('/auth/check/userToken', { userId: user._id }, { baseURL: process.env.MAIL_SERVICE }));
            if (resData && resData.code == 200) {
                setUserToken(resData.data);
            } else {
                setUserToken(null);
            }
        } catch (err) {
            console.error('Error checking auth:', err);
            setUserToken(null);
        }
    }

    const handleCallback = async () => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        if (code) {
            if (!user || !user._id) {
                console.error('User not logged in');
                return;
            }
            const resData = await dispatch(getData('/auth/callback', { code, userId: user._id }, { baseURL: process.env.MAIL_SERVICE }));
            if (resData && resData.code == 200) {
                window.location.href = location.origin + location.pathname;
            }
        }
    }

    useEffect(() => {
        checkAuth();
        handleCallback();
    }, []);


    return <div className="p-4 bg-white rounded w-96 shadow">
        <h1 className="text-xl font-bold mb-4">Microsoft App</h1>
        {!userToken ? (
            <Button onClick={handleAuth} type="primary" block>
                Authenticate with Microsoft
            </Button>
        ) : (
            <div className="flex items-center gap-2 font-semibold">
                <CheckCircleOutlined className="text-green-700 text-xl font-bold" />
                {userToken?.user?.email}
            </div>
        )}
    </div>;
};
export default GraphAuth;
